import { constants } from '@stefna/quasar-pilot-core/src/lib/constants';

constants.ALLOWED_POSTAL_CODES = [
  { value: 101, label: '101 - Reykjavík' },
  { value: 102, label: '102 - Reykjavík' },
  { value: 103, label: '103 - Reykjavík' },
  { value: 104, label: '104 - Reykjavík' },
  { value: 105, label: '105 - Reykjavík' },
  { value: 107, label: '107 - Reykjavík' },
  { value: 108, label: '108 - Reykjavík' },
  { value: 109, label: '109 - Reykjavík' },
  { value: 110, label: '110 - Reykjavík' },
  { value: 111, label: '111 - Reykjavík' },
  { value: 112, label: '112 - Reykjavík' },
  { value: 113, label: '113 - Reykjavík' },
  { value: 116, label: '116 - Reykjavík' },
  { value: 170, label: '170 - Seltjarnarnes' },
  { value: 200, label: '200 - Kópavogur' },
  { value: 201, label: '201 - Kópavogur' },
  { value: 203, label: '203 - Kópavogur' },
  { value: 210, label: '210 - Garðabær' },
  { value: 220, label: '220 - Hafnarfjörður' },
  { value: 221, label: '221 - Hafnarfjörður' },
  { value: 225, label: '225 - Álftanes' },
  { value: 270, label: '270 - Mosfellsbær' },
];
constants.DEFAULT_LOCATION = 1;
constants.DEFAULT_CATERING_LOCATION = 6;
constants.DEFAULT_COMPANY_CATERING_LOCATION = 4;
constants.DEFAULT_BUFFET_CATERING_LOCATION = 8;
constants.DEFAULT_DELIVERY_METHOD = 2;
constants.DEFAULT_PAYMENT_METHOD = 1;
constants.SESSION_COOKIE_USER_ID = 'userUid';
constants.SESSION_COOKIE_LOCATION_ID = 'locationUid';
constants.CATERING_CATEGORY = 14;
constants.CATERING_MAX_QUANTITY = 20;
constants.CATEGORY_OFFER_ID = 4;
constants.CATERING_TYPE_COMPANY = 'company';
constants.CATERING_TYPE_BUFFET = 'buffet';
constants.CATERING_BUFFET_READY_TIME_START_WEEKEND = '11:30';
constants.CATERING_BUFFET_READY_TIME_START_WEEKDAY = '11:00';

export default constants;
